import React from 'react';
import injectSheet from 'react-jss';

import { Row, Block } from '../common';
import theme from '../../theme';

const styles = {
  footerContainer: {
    padding: theme.margins.large,
    borderTopWidth: 1,
    borderTopStyle: 'solid',
    borderTopColor: theme.palette.secondary.light,
    backgroundColor: theme.palette.secondary.lightest,
  },
};

const Footer = ({ classes }) => {
  return (
    <Block className={classes.footerContainer}>
      <Row>
        <Block style={{ alignItems: 'center' }}>
          <div>About Us</div>
          <div>About Us</div>
          <div>About Us</div>
          <div>About Us</div>
        </Block>
        <Block style={{ alignItems: 'center' }}>
          <div>About Us</div>
          <div>About Us</div>
          <div>About Us</div>
        </Block>
        <Block style={{ alignItems: 'center' }}>
          <div>About Us</div>
          <div>About Us</div>
          <div>About Us</div>
          <div>About Us</div>
          <div>About Us</div>
          <div>About Us</div>
        </Block>
      </Row>
    </Block>
  );
};

export default injectSheet(styles)(Footer);
